import { render } from "./ShowTask.vue?vue&type=template&id=7c2fbc22"
import script from "./ShowTask.vue?vue&type=script&lang=js"
export * from "./ShowTask.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__